// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jm-6";
export var emphasizeQuantity = "_jm-3";
export var flatBottomCorners = "_jm-5";
export var productImage = "_jm-0";
export var quantityContainer = "_jm-2";
export var tooltip = "_jm-1";
export var wrapAndEllipsesOverflow = "_jm-4";